import React, { useEffect } from 'react';

const OnRenderComplete = ({ callback }) => {
  useEffect(() => {
    if (typeof callback === 'function') {
      try {
        callback();
      } catch (e) {
        // noop
      }
    }
  }, [callback]);
  return null;
};

export default OnRenderComplete;



